export default __webpack_public_path__ + "static/media/ic_settings_16.a10f95b4.svg";